<template>
  <div v-if="show && displayActionActive">
    <a
      :href="outboundLink"
      data-testid="viewer-cta"
      :target="target || '_blank'"
      :class="`bg-[${background}] text-[${color}] ${buttonClass}`"
      :style="{ background, color }"
      class="inline-block items-center gap-2 px-2 sm:ml-0 sm:px-4 py-2 text-xs sm:text-sm font-bold leading-4 border-2 border-transparent outline-none relative z-10"
    >
      {{ buttonText }}
    </a>
  </div>
</template>
<script setup lang="ts">
import { useCallToActionStore } from './../store/useCallToActionStore';
import { storeToRefs } from 'pinia';
import { watch, onMounted, computed } from 'vue';
import { useViewerItemStore } from '../store/useViewerItemStore';

const callToActionStore = useCallToActionStore();
const props = defineProps<{
  hoverOnly: boolean;
}>();

const itemStore = useViewerItemStore();

const show = computed(() => {
  if (showHoverableButton.value) {
    return true;
  }

  if (props.hoverOnly && !isHoverable.value) {
    return false;
  }
  if (!props.hoverOnly && isHoverable.value) {
    return false;
  }

  return true;
});

const loadCta = (val: string | undefined) => val && callToActionStore.getCallToAction(val);

onMounted(() => loadCta(itemStore.ctaId));
watch(() => itemStore.ctaId, loadCta);

const { target, isHoverable, background, color, buttonText, buttonClass, displayActionActive, outboundLink, showHoverableButton }: any =
  storeToRefs(callToActionStore);
</script>
<style lang="scss">
#cta-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
